import { IContactRespSchema } from '@monetize/types/app';
import { useCallback } from 'react';
import { MBox } from '../../../../components/Monetize';
import { QuoteBasicContactSelect } from '../../../../components/Quotes/QuoteBasicContactSelect';
import { QuoteBasicInfoLine } from '../../../../components/Quotes/QuoteBasicInfoLine';
import { useOneTimeInvoice } from './oneTimeInvoiceContext';

/**
 * Second column of the invoice setup card. Mirrors the quote setup contacts
 * column: inline selects for the two contacts an invoice has, with the drawer
 * behind the column's gear icon — and behind each row title — for address
 * source and contact management.
 */
export const OneTimeInvoiceBasicContacts = () => {
  const {
    accountId,
    shippingContact,
    billingContact,
    handleChangeContact,
    openContactsDrawer,
  } = useOneTimeInvoice();

  const handleChangeShippingContact = useCallback(
    (contact: IContactRespSchema) => handleChangeContact(contact, 'primary'),
    [handleChangeContact],
  );

  const handleChangeBillingContact = useCallback(
    (contact: IContactRespSchema) => handleChangeContact(contact, 'billing'),
    [handleChangeContact],
  );

  return (
    <MBox>
      <QuoteBasicInfoLine
        title="Shipping Contact"
        showRequired={!shippingContact}
        onTitleClick={openContactsDrawer}
        titleTooltip="Manage contacts"
      >
        <MBox mr="-2">
          <QuoteBasicContactSelect
            id="invoice-header-shipping-contact"
            // The row title is a button that opens the contacts drawer, so it
            // cannot double as this select's label.
            aria-label="Shipping Contact"
            value={shippingContact}
            onChange={handleChangeShippingContact}
            accountId={accountId}
          />
        </MBox>
      </QuoteBasicInfoLine>

      <QuoteBasicInfoLine
        title="Billing Contact"
        showRequired={!billingContact}
        onTitleClick={openContactsDrawer}
        titleTooltip="Manage contacts"
      >
        <MBox mr="-2">
          <QuoteBasicContactSelect
            id="invoice-header-billing-contact"
            aria-label="Billing Contact"
            value={billingContact}
            onChange={handleChangeBillingContact}
            accountId={accountId}
          />
        </MBox>
      </QuoteBasicInfoLine>
    </MBox>
  );
};
